import { render, staticRenderFns } from "./DefiBorrowFUSD.vue?vue&type=template&id=02f80c66&"
import script from "./DefiBorrowFUSD.vue?vue&type=script&lang=js&"
export * from "./DefiBorrowFUSD.vue?vue&type=script&lang=js&"
import style0 from "./DefiBorrowFUSD.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports